<app-factor-table
  [title]="'Total Fill-Ups'" [factors]="factorsData"
  [formatters]="formatters" [modalFilterHeaders]="modalFilterHeaders">
</app-factor-table>